import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import FloatingCTA from './components/FloatingCTA';
import Home from './components/Home';
import About from './components/About';
import HorseRides from './components/HorseRides';
import HorseRidePicnic from './components/HorseRidePicnic';
import Parties from './components/Parties';
import Photoshoots from './components/Photoshoots';
import Proposals from './components/Proposals';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-white">
        <Navbar />
        <FloatingCTA />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/horse-rides" element={<HorseRides />} />
            <Route path="/horse-ride-picnic" element={<HorseRidePicnic />} />
            <Route path="/parties" element={<Parties />} />
            <Route path="/photoshoots" element={<Photoshoots />} />
            <Route path="/proposals" element={<Proposals />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
    </HelmetProvider>
  );
}

export default App;
